import { useFileManagerContext } from 'modules/FileManagerV2/context/FileManagerContext';
import { loadIcon } from 'utils/filesUtils';
import { Tooltip } from 'primereact/tooltip';
import { Tag } from 'primereact/tag';
import GlobalTooltip from 'components/GlobalTooltip';
import { useContext } from 'react';
import { UserDetailsContext } from 'context/userDetailsContext';
import { useFileNavigation } from 'modules/FileManagerV2/hooks/ui/useFileNavigation';

export const TitleTemplate = ({ rowData, isGlobalFileManager }) => {
  const { setSelectedItem, modals, isClientFileManager } = useFileManagerContext();
  const userContext = useContext(UserDetailsContext);
  const { selectFile } = useFileNavigation({ userContext });

  const { setShowAddTag, setTagModalType, setShowUploadedVersionsModal } = modals;
  const sanitizedPk = rowData?.pk?.replace(/[^a-zA-Z0-9_-]/g, '_') || '';
  const tagArray = rowData?.tags || [];
  const displayedTags = tagArray.slice(0, 1); // Show only the first 2 tags
  const remainingTags = tagArray.slice(1);

  function handleTitleClick() {
    selectFile(rowData);
  }

  function handleTagClick(type) {
    setShowAddTag(true);
    setTagModalType(type);
    setSelectedItem(rowData);
  }

  function handleVersionControlClick() {
    setSelectedItem(rowData);
    setShowUploadedVersionsModal(true);
  }

  return (
    <>
      <div className="d-flex text-break flex-sm-row w-100">
        <span className="p-column-title text-break">Name</span>
        <div className="text-truncate">
          <span className="d-flex pointer align-items-center text-truncate">
            <span className="d-flex" onClick={handleTitleClick}>
              {rowData?.entry_type === 'folder' ? (
                <i className="icon-folder fa-lg"></i>
              ) : (
                loadIcon(rowData?.display_name?.split('.')?.reverse()[0])
              )}
            </span>

            <span className="ms-2 text-truncate">
              <span
                onClick={handleTitleClick}
                title={rowData?.display_name}
                className={
                  rowData?.is_read === true || rowData?.is_read === undefined || rowData?.entry_type === 'folder'
                    ? 'pointer text-break text-primary-dark'
                    : 'pointer text-bold text-primary-dark'
                }
              >
                {rowData?.display_name}
              </span>
            </span>

            {rowData?.entry_type !== 'folder' && rowData?.versions?.length > 0 ? (
              <span role="button" onClick={handleVersionControlClick}>
                <GlobalTooltip tooltip="File Versions" className="ms-2">
                  <i className="fas fa-history" aria-hidden="true" />
                </GlobalTooltip>
              </span>
            ) : null}

            {rowData?.entry_type !== 'folder' && rowData?.is_virtual && (
              <span>
                <GlobalTooltip tooltip={`Linked to ${rowData?.communication_type}`} className="ms-2" position="top">
                  <i className="fas fa-info-circle" aria-hidden="true" />
                </GlobalTooltip>
              </span>
            )}
          </span>

          {!isClientFileManager && !isGlobalFileManager && (
            <div className="tag-wrp d-flex flex-wrap pt-2">
              {rowData && rowData?.tags && rowData?.tags?.length ? (
                <>
                  {displayedTags?.map((val, index) => (
                    <span className="text-break file-manager-ellipsis-text" title={val} key={index}>
                      <Tag value={val} className="case-d-tag me-1 mb-1 case-list-tag-ellipsis-text " />
                    </span>
                  ))}

                  {/* Show "+more" if there are more than 2 tags */}
                  {remainingTags?.length > 0 && (
                    <>
                      <Tag
                        className={`p-mr-2 me-1 mb-1 tag case-d-tag more-tag more-tag-${sanitizedPk}`}
                        rounded
                        value={`+${remainingTags?.length} more`}
                      />

                      <Tooltip target={`.more-tag-${sanitizedPk}`} position="top">
                        {remainingTags?.map((tag, index) => (
                          <Tag key={index} value={tag} className="case-d-tag me-1 mb-1" />
                        ))}
                      </Tooltip>
                    </>
                  )}
                  <i onClick={() => handleTagClick('edit')} className="tag icon-add ms-0 pointer d-flex align-items-center"></i>
                </>
              ) : (
                <span className="F-size12 tag m-1 ms-0 pointer" onClick={(e) => handleTagClick('add')}>
                  <i className="icon-add"></i>Add Tag
                </span>
              )}
            </div>
          )}
        </div>
      </div>
    </>
  );
};
